<template>
  <div>

    <div class="program-guide-section explore-section">

		<div class="row mid-panel top-explore-fields-row" style="border: none; overflow: hidden; height: 92px;">

				<div class="left-col">
					<div class="form-field">
						<input type="checkbox" class="checkbox" v-model="useProfile">
					</div>
					<div class="profile-info-label">use profile info</div>
				</div>

				<div class="right-col">
					<b-input-group class="row data-row">

						<div class="form-field major" v-if="showMajorPivot">
						  	<label for="state">{{majorPivotLabel}}</label>
						  	<v-select class="select-field" v-model='major' :options='majors' placeholder="Select or type in Major(s)"></v-select>
						</div>

						<div class="form-field minor" v-if="showMinorPivot">
						  	<label for="state">{{minorPivotLabel}}</label>
						  	<v-select class="select-field" v-model='minor' :options='minors' placeholder="Select or type in Minor(s)"></v-select>
						</div>

	          			<div class="form-field career-interest" v-if="showIndustryPivot">
						  	<label for="state">{{industryPivotLabel}}</label>
						  	<v-select class="select-field" v-model='industry' :options='industries' placeholder="Select or type in Job"></v-select>
						</div>

						<div class="form-field career-interest" v-if="showCareerPivot">
						  	<label for="state">{{careerPivotLabel}}</label>
						  	<v-select class="select-field" v-model='career' :options='careers' placeholder="Select or type in Job"></v-select>
						</div>
						<!--
						<b-dropdown right variant="link" no-caret class="create-section-menu">
							<template slot="button-content">
								<span class="icon-menu3x3" aria-label="dropdown menu"></span>
							</template>
						</b-dropdown>
						-->

						<div class="btn_container">
							<b-btn class="go-btn" @click="search()">Go</b-btn>
						</div>

					</b-input-group>



			</div>

		</div>

		<div class="row explore_bottom_section">

			<div class="col-3 left-tab-panel">
				<div class="facets">
					<div class="main_head">
						<div class="icon-filter"></div>
						<div class="head_txt">Narrow Your Results</div>
					</div>
					<div class="content-section">
						<b-form-group label="">
	        				<b-form-radio-group v-model="selected">
		  					  	<b-form-radio name="filter" value="all">show all</b-form-radio>

			  					<b-form-radio  name="filter" value="careers">careers</b-form-radio>
			  					<b-form-radio name="filter" value="programs">programs</b-form-radio>
                  <b-form-radio name="filter" value="insights">insights</b-form-radio>
			  					<b-form-radio  name="filter" value="streams">streams</b-form-radio>
			  					<b-form-radio  name="filter" value="catalogs">course catalogs</b-form-radio>
                  <b-form-radio  name="filter" value="courses">external courses</b-form-radio>
                  <!--
			  					<b-form-radio name="filter" value="jobs">jobs</b-form-radio>
			  					<b-form-radio name="filter" value="persons">person</b-form-radio>
			  					<b-form-radio  name="filter" value="clubs">clubs</b-form-radio>
			  					<b-form-radio  name="filter" value="events">events</b-form-radio>
                  -->
	       					</b-form-radio-group>
						</b-form-group>
					</div>
			  	</div>
			</div>

	        <div class="col-9 mid-panel explore-mid-panel">
                <explore-insight-list :type="'insights'"></explore-insight-list>
                <explore-list :type="'programs'" v-if="currentFacet === 'all' || currentFacet === 'programs'"></explore-list>
                <explore-list :type="'careers'" v-if="currentFacet === 'all' || currentFacet === 'careers'"></explore-list>
                <explore-search :id="id" :type="'streams'" :index="streamsIndex" :source="streamSource" :libraryList="libraryList" :major="major" :minor="minor" :career="career" :industry="industry" :reload="reload"
            		v-if="currentFacet === 'all' || currentFacet === 'streams'"></explore-search>
                <explore-search :id="id" :type="'catalogs'" :index="catalogsIndex" :source="catalogSource" :libraryList="libraryList" :major="major" :minor="minor" :career="career" :industry="industry" :reload="reload"
              		v-if="currentFacet === 'all' || currentFacet === 'catalogs'"></explore-search>
                <explore-search :id="id" :type="'courses'" :index="coursesIndex" :source="courseSource" :libraryList="libraryList" :major="major" :minor="minor" :career="career" :industry="industry" :reload="reload"
              		v-if="currentFacet === 'all' || currentFacet === 'courses'"></explore-search>
	        </div>

			<!--
	  		<div class="col-3 right-panel career-panel">
	    		<add-to-stream-explore></add-to-stream-explore>
	  		</div>
	  		-->

		</div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import ExploreList from './ExploreList'
import ExploreSearch from './ExploreSearch'
import AddToStreamExplore from './AddToStreamExplore'
import ExploreInsightList from './ExploreInsightList'

export default {
  name: 'explore',
  props: ['reload'],
  components: {
    AddToStreamExplore,
    ExploreList,
    ExploreSearch,
    ExploreInsightList
  },
  data: () => {
    return {
      id: 0,
      useProfile: false,
      major: '',
      career: '',
      minor: '',
      industry: '',
      selected: 'all',
      libraryList: [],
      streamsIndex: 'studentpathway,careertag',
      catalogsIndex: 'careertag',
      catalogSource: ['tagName', 'score', 'title', 'type', 'entityUuid', 'description', 'owningLibraryId', 'entityLastModified', 'appliedTagMap', 'institutionId', 'thumbnailURIList', 'thumbnail'],
      streamSource: ['streamId', 'streamTitle', 'type', 'tagName', 'score', 'title', 'entityUuid', 'description', 'owningLibraryId', 'entityLastModified', 'appliedTagMap', 'institutionId', 'thumbnailURIList', 'thumbnail'],
      userId: localStorage.getItem('userid'),
      userObj: JSON.parse(localStorage.getItem('userobj')),
      coursesIndex: 'deliverycontext',
      courseSource: ['uuid',
        'title',
        'description',
        'creationTime',
        'lastUpdatedTime',
        'type',
        'ancestor',
        'owningLibraryId',
        'ownerName',
        'ownerId',
        'originUuid',
        'thumbnail',
        'appliedTagMap',
        'facetedCourseTags',
        'maxSeats',
        'currentSeats',
        'roomInformation',
        'meetingDays',
        'meetingFromTime',
        'meetingToTime',
        'specialInstructions',
        'crn',
        'division',
        'department',
        'departmentCode',
        'subject',
        'subjectCode',
        'level',
        'maxCredit',
        'minCredit',
        'creditHour',
        'prerequisites',
        'corequisities',
        'catalogCourseId',
        'instructorNames',
        'num',
        'meetingDaysRaw',
        'meetingDaysFormatted',
        'termCode',
        'timeSlots',
        'courseFlags',
        'catalogId',
        'level',
        'courseMajors',
        'courseMajorCodes',
        'courseType',
        '_score'
      ],
      selectedStreamUuid: ''
    }
  },

  mounted () {
    this.loadExploreDetails()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadMajors',
      'loadMinors',
      'loadCareersPivot',
      'loadIndustries',
      'loadMajorInformation',
      'loadCareerResults',
      'loadProgramResults',
      'setCurrentFacet',
      'loadAllLibraryForUser',
      'loadExploreSubstreamEntities',
      'populateStreamsForUser',
      'exploreStreamSelected',
      'updateExploreSearchState',
      'resetExploreData',
      'loadCareerInformation',
      'loadCareerResultsUsingSocCode',
      'loadProgramResultsUsingSocCode',
      'loadMajorMinor',
      'loadUserCareerGoal'
    ]),
    loadExploreDetails () {
      if (this.reload) {
        this.major = ''
        this.career = ''
        this.minor = ''
        this.industry = ''
        this.selected = 'all'
        this.resetExploreData()
      }
      this.populateStreamsForUser({userId: this.userId}).then(results => {
        let selectedStreamUuid = this.selectDefaultStream(results)
        this.loadExploreSubstreamEntities({streamUuid: selectedStreamUuid})
      })
      this.loadMajors()
      this.loadMinors()
      this.loadCareersPivot()
      this.loadIndustries()
      this.selected = this.currentFacet
      this.loadAllLibraryForUser().then(learningSpaces => {
        this.libraryList = []
        if (learningSpaces && learningSpaces.length > 0) {
          for (var i = 0; i < learningSpaces.length; i++) {
            const category = learningSpaces[i].category
            if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
              this.libraryList.push(learningSpaces[i].uuid)
            }
          }
        }
      })
      this.major = this.selectedMajor ? this.selectedMajor : ''
      this.minor = this.selectedMinor ? this.selectedMinor : ''
      this.industry = this.selectedIndustry ? this.selectedIndustry : ''
      this.career = this.selectedCareer ? this.selectedCareer : ''
      this.search()
    },
    async setPivotsBasedOnProfile () {
      if (this.userObj.major1) {
        let majorMinor = await this.loadMajorMinor({code: this.userObj.major1})
        if (majorMinor && majorMinor.name) {
          this.major = majorMinor.name
        } else {
          this.major = this.userObj.major1Title
        }
      }
      if (this.userObj.minor1) {
        let majorMinor = await this.loadMajorMinor({code: this.userObj.minor1})
        if (majorMinor && majorMinor.name) {
          this.minor = majorMinor.name
        } else {
          this.minor = this.userObj.minor1Title
        }
      }
      this.career = await this.loadUserCareerGoal()
    },
    selectDefaultStream (results) {
      if (!results || !results.length || results.length <= 0) {
        return {}
      }
      let userId = this.userId
      let defaultSet = false
      let streamUuid
      results.forEach((stream) => {
        if (!defaultSet && stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
          streamUuid = stream.uuid
          defaultSet = true
        }
      })
      if (defaultSet) {
        this.selectedStreamUuid = streamUuid
      } else {
        // there is no stream that the user has access to, clearing this here to prevent
        // issues where a stream is deleted on KO side.
        this.selectedStreamUuid = {}
      }
      this.exploreStreamSelected({streamUuid: this.selectedStreamUuid})
      return this.selectedStreamUuid
    },
    search () {
      if (this.major) {
        this.updateExploreSearchState({selectedMajor: this.major, selectedMinor: this.minor, selectedIndustry: this.industry, selectedCareer: this.career})
        this.loadMajorInformation(this.major).then(res => {
          if (res && (res.cipCode || res.code)) {
            let tempCode = res.code
            if (res.cipCode) {
              tempCode = res.cipCode
            }
            this.loadCareerResults(tempCode)
            this.loadProgramResults(tempCode)
          }
        })
      } else if (this.career) {
        this.updateExploreSearchState({selectedMajor: this.major, selectedMinor: this.minor, selectedIndustry: this.industry, selectedCareer: this.career})
        this.loadCareerInformation({career: this.career, institutionId: this.userObj.institutionId}).then(res => {
          if (res && res.code) {
            this.loadCareerResultsUsingSocCode(res.code)
            this.loadProgramResultsUsingSocCode(res.code)
          }
        })
      }
      this.id = this.id + 1
    }
  },

  computed: {
    ...mapState({
      'majors': state => state.explore.majors,
      'minors': state => state.explore.minors,
      'careers': state => state.explore.careers,
      'industries': state => state.explore.industries,
      'careerResults': state => state.explore.careerResults,
      'programResults': state => state.explore.programResults,
      'selectedMajor': state => state.explore.selectedMajor,
      'selectedMinor': state => state.explore.selectedMinor,
      'selectedIndustry': state => state.explore.selectedIndustry,
      'selectedCareer': state => state.explore.selectedCareer,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    }),
    showMajorPivot () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showMajor') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    majorPivotLabel () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showMajor' && flags[i].label) {
            return flags[i].label
          }
        }
      }
      return 'Major'
    },
    showMinorPivot () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showMinor') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    minorPivotLabel () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showMinor' && flags[i].label) {
            return flags[i].label
          }
        }
      }
      return 'Minor'
    },
    showCareerPivot () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCareer') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    careerPivotLabel () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCareer' && flags[i].label) {
            return flags[i].label
          }
        }
      }
      return 'Career'
    },
    showIndustryPivot () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showIndustry') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    industryPivotLabel () {
      let pivotFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PIVOTS_FEATURE_ID]
      if (pivotFeature) {
        let flags = pivotFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showIndustry' && flags[i].label) {
            return flags[i].label
          }
        }
      }
      return 'Industry'
    }
  },

  watch: {
    currentFacet (newCurrentFacet) {
      this.selected = newCurrentFacet
    },
    selected (newSelected) {
      this.setCurrentFacet(newSelected)
      this.search()
    },
    useProfile (newUseProfile) {
      if (newUseProfile) {
        this.setPivotsBasedOnProfile()
      } else {
        this.major = ''
        this.career = ''
        this.minor = ''
        this.industry = ''
        this.selected = 'all'
        this.resetExploreData()
      }
    }
  }
}
</script>
<style>
.content-section {
  background: transparent!important;
}
</style>



// WEBPACK FOOTER //
// src/app/explore/components/Explore.vue